var _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentSectionTitleDeco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 171 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 161.994,
    height: 1,
    transform: "matrix(-1 0 0 1 161.993 0.00195312)",
    fill: "#5948C8",
    className: "svg-elem-1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.3811,
    height: 1.19075,
    transform: "matrix(-0.668951 -0.743307 -0.668951 0.743307 170.935 9.95312)",
    fill: "#5948C8",
    className: "svg-elem-2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 153.894,
    height: 1,
    transform: "matrix(-1 0 0 1 164.694 3.00195)",
    fill: "url(#paint0_linear_146_1383)",
    className: "svg-elem-3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_1383",
    x1: 0.899967,
    y1: 0.999771,
    x2: 77.8476,
    y2: 1.40481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5948C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5948C8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentSectionTitleDeco);
export default __webpack_public_path__ + "static/media/content-section-title-deco.fbb723da81ff49c7326aa96ee492416d.svg";
export { ForwardRef as ReactComponent };